import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Form, Errors, actions, Control} from 'react-redux-form';
import {FormGroup, FormControl,ControlLabel, Grid, Row, Col, Button, Checkbox} from 'react-bootstrap';
import PageTitle from "../../common/page-title/index";
import UserTitleSelector from "../../common/form/user/user-title-selector";
import UserFirstNameInput from "../../common/form/user/user-first-name-input";
import UserLastNameInput from "../../common/form/user/user-last-name-input";
import ArrowButton from "../../common/button-arrow";
import {getAdminMyProfile, saveAdminMyProfile} from '../../../actions/user'
import {validators} from '../../../utils/validators';

import './style.css';

class MyProfile extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.dispatch(getAdminMyProfile());
  }

  onSubmit = (payload) => {
    const payLoad = {...payload};
    this.props.dispatch(actions.submitFields('deep.admin_my_profile', saveAdminMyProfile(payLoad)));
  };

  render() {
    const profile = this.props.profile.attributes;

    return (
      <Grid bsClass="container" fluid className="my-profile">
        <Row>
          <Col md={12}>
            <PageTitle>My profile</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <h4>Personal Details</h4>
          </Col>
        </Row>
        <Form model="deep.admin_my_profile"
              onSubmit={(payload) => this.onSubmit(payload)}>
          <Row className="show-grid profile-details">
            <Col md={6}>
              <UserTitleSelector/>

              <UserFirstNameInput/>

              <UserLastNameInput/>
            </Col>

            <Col md={6}>
              <FormGroup>
                <ControlLabel>Communication preferences*</ControlLabel>
                <Errors
                  show={{touched: true}}
                  className="errors"
                  model="deep.about_you.user"
                  messages={{
                    communication: 'You must select at least one communication preference.'
                  }}/>

                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Control.checkbox model=".comms_email" component={Checkbox}>Email</Control.checkbox>
                    </FormGroup>
                  </Col>
                  <Col md={9}>
                    <FormGroup controlId="email">
                      <Control.text
                        model=".email"
                        type="email"
                        placeholder="Email"
                        changeAction={this.changeEmailMobileAction}
                        validators={{
                          required: (val) => !this.props.comms_email || validators.required(this.updateErrors, 'email')(val)
                        }}
                        disabled={!this.props.comms_email}
                        component={FormControl}/>

                      <Errors
                        show={{touched: true, focus: false}}
                        className="errors"
                        model=".email"/>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Control.checkbox model=".comms_mobile" component={Checkbox}>Mobile</Control.checkbox>
                    </FormGroup>
                  </Col>
                  <Col md={9}>
                    <FormGroup controlId="mobile">
                      <Control.text
                        model=".mobile"
                        type="tel"
                        placeholder="Mobile"
                        changeAction={this.changeEmailMobileAction}
                        validators={{
                          required: (val) => !this.props.comms_mobile || validators.required(this.updateErrors, 'mobile')(val)
                        }}
                        disabled={!this.props.comms_mobile}
                        component={FormControl}/>

                      <Errors
                        show={{touched: true, focus: false}}
                        className="errors"
                        model=".mobile"/>
                    </FormGroup>
                  </Col>
                </Row>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <ArrowButton color="grey"
                           disabled={!this.props.form.$form.valid || !(this.props.comms_email || this.props.comms_mobile)}
                           className="pull-right">Save</ArrowButton>
            </Col>
          </Row>
        </Form>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.currentUser.profile,
    comms_mobile: !!state.deep.admin_my_profile.comms_mobile,
    comms_email: !!state.deep.admin_my_profile.comms_email,
    form: state.deep.forms.admin_my_profile
  };
};

export default connect(mapStateToProps)(MyProfile);



// WEBPACK FOOTER //
// ./src/components/admin/my-profile/index.jsx